import React, { Component } from "react";
import { connect } from "react-redux";
import IntlMessages from "../../../utils/IntlMessages";
import { signupClosePopup } from "../../../actions";

class PopupSignUpNoti extends Component {
  onClickClose = (e) => {
    this.props.signupClosePopup(this.props.clearClassPopup);
  };

  onClickAbbot = (e) => {
    document.location = "https://www.acare.co.in";
  };

  render() {
    let btnClass = "btn btn-wrs mb-3";
    let btnClassCancel = "btn btn-wrs-clear mb-3";
    // if (!this.props.displayPopupNoti) {
    //   return <div></div>;
    // }
    return (
      <div
        className="modal fade show"
        role="dialog"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body text-center">
              <i className="icon icon-ico-alert-1"></i>
              <h3 className="mt-3">
                <IntlMessages id="popup.acare.title"></IntlMessages>
              </h3>
            </div>
            <div className="modal-foot container">
              <button
                type="button"
                className={btnClass}
                onClick={this.onClickAbbot}
              >
                <IntlMessages id="popup.acare.btn"></IntlMessages>
              </button>
              <button
                type="button"
                className={btnClassCancel}
                onClick={this.onClickClose}
              >
                <IntlMessages id="popup.close"></IntlMessages>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  setting,
  // signup: { displayPopupNoti, clearClassPopup },
}) => {
  const {
    locale: { locale },
  } = setting;
  return { locale, 
    // displayPopupNoti, clearClassPopup 
  };
};

export default connect(mapStateToProps, {
  signupClosePopup,
})(PopupSignUpNoti);
